import React, { useEffect, useRef } from 'react';
import { CaptchEtat } from 'captchetat-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CaptchaEtatInput from 'components/captcha/CaptchaEtatInput';
import { API_CAPTCHA_ETAT_URL } from 'constants/apiUrls.constants';

const CaptchaEtat = ({ setInfoCaptchaEtat, setCaptchaRecharge, captchaRecharge }) => {
    const captchaEndpoint = `${process.env.REACT_APP_API_DETENTEURS_URL}${API_CAPTCHA_ETAT_URL}`;
    const urlBackend = captchaEndpoint;
    const captchaStyleName = 'captchaFR';
    const alternativeImage = 'Alternative image';
    const captchetatRef = useRef(null);

    const onCaptchaChange = (captcha) => {
        setInfoCaptchaEtat({ id: captcha.uuid });
    };

    // Effet pour recharger le captcha si demandé par le parent
    useEffect(() => {
        if (captchaRecharge && captchetatRef.current) {
            captchetatRef.current?.reloadImage();
            setCaptchaRecharge(false);
        }
    }, [captchaRecharge, setCaptchaRecharge]);

    return (
        <div className="captcha-etat">
            <CaptchEtat
                urlBackend={urlBackend}
                captchaStyleName={captchaStyleName}
                altImage={alternativeImage}
                onChange={onCaptchaChange}
                className="captchetat"
                ref={captchetatRef}
            />
            <CaptchaEtatInput setInfoCaptchaEtat={setInfoCaptchaEtat} />
        </div>
    );
};

CaptchaEtat.propTypes = {
    setInfoCaptchaEtat: PropTypes.func.isRequired,
    setCaptchaRecharge: PropTypes.func.isRequired,
    captchaRecharge: PropTypes.bool,
};

export default connect((state) => {
    const { erreur } = state.compte.creer.validation;
    return {
        erreur,
    };
})(CaptchaEtat);
